module.exports = __webpack_public_path__ + "static/media/game-background-functions.19c88a26.jpg";